import { useMemo } from 'react';
import Fuse from 'fuse.js';
import IUserList from '../../utils/UserList/UserList.interface';
import { IPreset } from '../../utils/ModulePresets/preset.interface';
import IModuleList from '../../utils/ModuleList/ModuleList.interface';

export const usePartnerFuse = (partnerList: IUserList[]) => {
  return useMemo(() => {
    return new Fuse(partnerList, {
      keys: ['companyName', 'email'],
      threshold: 0.3
    });
  }, [partnerList]);
};

export const usePresetFuse = (presets: IPreset[]) => {
  return useMemo(() => {
    return new Fuse(presets, {
      keys: ['presetName', 'moduleList'],
      threshold: 0.3
    });
  }, [presets]);
};

export const useModuleFuse = (modules: IModuleList[]) => {
  return useMemo(() => {
    return new Fuse(modules, {
      keys: ['moduleName', 'moduleInfo'],
      threshold: 0.3
    });
  }, [modules]);
};
